<router-outlet></router-outlet>

<ngx-spinner bdOpacity=0.9 bdColor="rgba(41,41,41,0.68)" size="medium" color="#ffffff" type="ball-clip-rotate-multiple" [fullScreen]="true">
    <p style="color: white; font-weight: bold;"> Loading... </p>
</ngx-spinner>
